import React from "react";
import { Outlet } from "react-router-dom";
import HeaderOne from "../components/HeaderOne";
import FooterOne from "../components/FooterOne";
import Modal from "../components/Modal";
import EbookForm from "../components/EbookForm";
import GetDemoForm from "../components/GetDemoForm";
import CalendlyModal from "../components/CalendlyModal";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import TerminalDetails from "../components/TerminalDetails";

const MasterLayout = ({
  openEbookModal,
  setOpenEbookModal,
  openGetDemoModal,
  setOpenGetDemoModal,
  openCalendlyModal,
  setOpenCalendlyModal,
  closeModal, // from useModals
  isModalOpen,
  handleCloseModal,
  selectedCard,
}) => {
  const { i18n, t } = useTranslation();

  const websiteHy = {
    "@type": "WebSite",
    "@id": "https://tamias.am/#website",
    url: "https://tamias.am/",
    name: "Tamias",
    description:
      "Tamias-ը գույքագրման և ունեցվածքի կառավարման համակարգ է, որը նախատեսված է պահեստների, արտադրամասերի, պետական և սպասարկման ոլորտի հաստատությունների համար։",
    inLanguage: "hy",
    publisher: { "@id": "https://tamias.am/#organization" },
  };

  const websiteEn = {
    ...websiteHy,
    name: "Tamias",
    description:
      "Tamias is an asset and inventory management system designed for warehouses, manufacturing, and service or public organizations.",
    inLanguage: "en",
    publisher: { "@id": "https://tamias.am/#organization" },
  };

  const orgHy = {
    "@type": "Organization",
    "@id": "https://tamias.am/#organization",
    name: "ITResources",
    url: "https://tamias.am/",
    logo: {
      "@type": "ImageObject",
      url: "https://tamias.am/images/logo.svg",
    },
    sameAs: [
      "https://www.facebook.com/ITResources.am",
      "https://www.linkedin.com/company/itresources/",
    ],
    description:
      "ITResources-ը ստեղծում է բիզնեսի համար թվային լուծումներ, ներառյալ գույքագրման, հերթերի կառավարման և խելացի ավտոմատացման համակարգեր։",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+374 41 996008",
      contactType: "Customer Support",
      areaServed: "AM",
      availableLanguage: ["Armenian", "English"],
    },
  };

  const orgEn = {
    ...orgHy,
    description:
      "ITResources builds digital solutions for businesses, including inventory management, queue systems, and smart automation platforms.",
  };

  const globalSchema = {
    "@context": "https://schema.org",
    "@graph": [
      i18n.language === "hy" ? orgHy : orgEn,
      i18n.language === "hy" ? websiteHy : websiteEn,
      {
        "@type": "WebSite",
        "@id": "https://tamias.am/#website",
        url: "https://tamias.am/",
        name: "Tamias",
        inLanguage: i18n.language,
        publisher: { "@id": "https://tamias.am/#organization" },
      },
    ],
  };

  return (
    <>
      <Helmet>
        <html lang={i18n.language} />
        <title>{t("meta.title")}</title>
        <meta name="description" content={t("meta.description")} />
        <meta name="keywords" content={t("meta.keywords")} />

         <script type="application/ld+json">
          {JSON.stringify(globalSchema)}
        </script>
      </Helmet>

      {/* Header */}
      <HeaderOne setOpenGetDemoModal={setOpenGetDemoModal} />

      {/* Page Content */}
      <Outlet />

      {/* Footer */}
      <FooterOne />

      {/* Modals */}
      <Modal
        isOpen={openEbookModal}
        onClose={() => closeModal("ebook")}
        title={t("becomeSellerTwo.ebookModal.title")}
      >
        <EbookForm />
      </Modal>

      <Modal
        isOpen={openGetDemoModal}
        onClose={() => closeModal("getDemo")}
        title={t("getDemoForm.title")}
      >
        <GetDemoForm />
      </Modal>

      <Modal
        isOpen={openCalendlyModal}
        onClose={() => closeModal("calendly")}
        large="large"
      >
        <CalendlyModal />
      </Modal>

      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        large="large"
        withoutLogo
      >
        <TerminalDetails selectedCard={selectedCard} />
      </Modal>
    </>
  );
};

export default MasterLayout;
